import * as getters from "./general.getters";
import * as actions from "./general.actions";
import * as mutations from "./general.mutations";

const state = {
    isMAPage: false,
    windowWidth: window.innerWidth,
    activeBreakpoints: [],
    breakpoints: {
        mobile: 350,
        'mobile-landscape': 480,
        tablet: 760,
        'tablet-landscape': 980,
        desktop: 1200,
        notebook: 1440,
        laptop: 1650,
        page: 1920,
    },
    dimmed: false,
    locked: false,
    mobile: false,
    portableDevice: false,
    mobileSidebarHeightMode: 'middle',
    sidebarDetailOpen: false,
    interimStopMessageVisible: false,
    mobileSearchVisible: false,
    dialogAlreadyVisible: false
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}